import type { FormState } from "react-hook-form";

export function isDirty<T extends Record<string, unknown>>(
  formState: FormState<T>,
) {
  return Object.keys(formState.dirtyFields).length > 0 || formState.isDirty;
}
